import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeDocumentList = async (IdeaId, UserId) => {
  console.log("GetInitiativeDocumentList", IdeaId);
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  if (!IdeaId) {
    console.warn("IdeaId not prst.");
    return;
  }
  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeDocumentList`,
      {
        params: { IdeaId, UserId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative document list:", error);
    throw new Error("Failed to fetch initiative document list");
  }
};

export default GetInitiativeDocumentList;
